// Basic Functions
$(document).ready(function(){

	// ##############################################
	// ################## fancybox ##################
	// ##############################################  
  
  $('.image-fancybox').on('click', function (e) {
    e.preventDefault();
    var target = this.href;
    //console.info(target);
    $.fancybox.open({
      src: target,
      type: 'image',
      opts: {
        buttons: [
        //"zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        "download",
        //"thumbs",
        "close"],
        afterShow: function afterShow(instance, current) {
          //console.info( 'done!' );
        }
      }
    });
  });

  
  $().fancybox({
    selector : '.slider-gallery .slick-slide .gallery-fancybox',
    backFocus : false,
    //thumbs: {
    //  autoStart : true
    //},
    preventCaptionOverlap: true,
    arrows: true,
    buttons: [
      //"zoom",
      //"share",
      //"slideShow",
      //"fullScreen",
      "download",
      //"thumbs",
      "close"],
    //afterShow : function( instance, current ) {
    //  current.opts.$orig.closest(".slick-initialized").slick('slickGoTo', parseInt(current.index), true);
    //}
  });


	// ##############################################
	// ################ Match Height ################
	// ##############################################  

  //$('.slider-teaser .tile').matchHeight();
  //$('.teaser-details-inner').matchHeight();

  

    
  // ##############################################
	// ################## On Screen #################
	// ##############################################  
  
	jQuery.fn.isOnScreen = function()
	{
	    var win = jQuery(window);
 
	    var viewport = {
	        top : win.scrollTop(),
	        left : win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();
 
	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();
 
	    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};
  
  // ##############################################
	// #################### forms ###################
	// ##############################################  

  $('input, textarea').each(function(){
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });
  
  $('input, textarea').focusin(function(){
    $(this).addClass("focus");
  });

  $('input, textarea').focusout(function(){
    $(this).removeClass("focus");
    if ($(this).val() != "") {
      $(this).addClass("has-content");
    } else {
      $(this).removeClass("has-content");
    }
  });

  // ##############################################
	// ################## Tooltip ###################
	// ##############################################
  
  $('.tooltipster-tooltip').tooltipster({
    trigger: 'click',
    animation: 'fade',
    //'fade', 'grow', 'swing', 'slide', 'fall'
    delay: 200,
    theme: 'tooltipster-tmt',
    interactive:true,
    side: 'bottom',
    functionBefore: function(instance, helper) {
      //console.log('open');
      //console.log(instance._$origin[0]);
      //console.log(instance._$origin[0].offsetParent);
      $(instance._$origin[0]).addClass('open');
      $(instance._$origin[0].offsetParent).closest('section').addClass('open');
    },
    functionAfter: function(instance, helper) {
      //console.log('close');
      $(instance._$origin[0]).removeClass('open');
      $(instance._$origin[0].offsetParent).closest('section').removeClass('open');
    }
  });  

  // ##############################################
	// ############# Customized Tooltips ############
	// ##############################################  

  $('.product-tooltip').on('click', function(e) {
    e.preventDefault();
    var target = this.hash;
    //console.log(target);
    $(target).siblings('.product-modal').removeClass('show');
    $(target).toggleClass('show');
    $(target).find('.modal-body').collapse('show');
  });
  $('.product-tooltip-close').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.product-modal').removeClass('show');
    $(this).closest('.product-tooltips').find('.modal-body').collapse('hide');
  });
  $('.product-tooltips img').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.product-tooltips').find('.product-modal').removeClass('show');
    $(this).closest('.product-tooltips').find('.modal-body').collapse('hide');
  });

    
});


// WEBPACK FOOTER //
// ./js/parts/base.js